import HeartArrowIcon from "./images/icons/heart-arrow.svg?react";
import HeartPinkIcon from "./images/icons/heart-pink.svg?react";
import HeartRedIcon from "./images/icons/heart-red.svg?react";
import "./ValentineTheme.scss";

export const ValentineTheme = () => {
  return (
    <>
      <div className="rightHeartsDecor">
        <span className="pinkHeartIcon"><HeartPinkIcon /></span>
        <span className="redHeartIcon"><HeartRedIcon /></span>
      </div>
      <div className="centerRightHeartsDecor">
        <span className="pinkHeartLeftIcon"><HeartPinkIcon /></span>
        <span className="arrowHeartIcon"><HeartArrowIcon /></span>
        <span className="pinkHeartRightIcon"><HeartPinkIcon /></span>
        <span className="redHeartIcon"><HeartRedIcon /></span>
      </div>
      <div className="centerHeartsDecor">
        <span className="redHeartIcon"><HeartRedIcon /></span>
        <span className="pinkHeartLeftIcon"><HeartPinkIcon /></span>
        <span className="pinkHeartRightIcon"><HeartPinkIcon /></span>
      </div>
      <div className="leftHeartsDecor">
        <span className="arrowHeartIcon"><HeartArrowIcon /></span>
        <span className="pinkHeartTopIcon"><HeartPinkIcon /></span>
        <span className="pinkHeartBottomIcon"><HeartPinkIcon /></span>
      </div>
    </>
  );
};
